/**
 * Client-side mirror of backend/src/utils/timeDecay.js
 * Keep in sync if business rules change.
 */

export function calculateDecayedPrice({
  ceilingPrice,
  floorPrice,
  stayDate,
  decayWindowDays = 90,
  now = new Date(),
}) {
  const daysUntilStay = Math.floor(
    (new Date(stayDate).getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
  );

  let decayPercent;
  if (daysUntilStay >= decayWindowDays) decayPercent = 0;
  else if (daysUntilStay <= 0) decayPercent = 1;
  else decayPercent = 1 - daysUntilStay / decayWindowDays;

  const currentPrice = Math.round(ceilingPrice - decayPercent * (ceilingPrice - floorPrice));
  return { currentPrice, daysUntilStay, decayPercent };
}

export function calculateCancellationRefund(paidAmount, stayDate, now = new Date()) {
  const daysUntilStay = Math.floor(
    (new Date(stayDate).getTime() - now.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (daysUntilStay >= 60) return { buyerRefund: paidAmount, ownerPayout: 0, policy: 'full_refund' };
  if (daysUntilStay >= 30) {
    const half = Math.round(paidAmount / 2);
    return { buyerRefund: half, ownerPayout: paidAmount - half, policy: 'partial_refund' };
  }
  return { buyerRefund: 0, ownerPayout: paidAmount, policy: 'no_refund' };
}
